/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMoneyPoolPublicPreview} from '../api'

 export const useQueryGetMoneyPoolPublicPreview = createReactQueryHook('getMoneyPoolPublicPreview', getMoneyPoolPublicPreview)
